import { useState, useCallback } from "react";

export const useStepNavigation = (totalSteps: number = 5) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isAnimating, setIsAnimating] = useState(false);

  const handleNext = useCallback(() => {
    if (currentStep < totalSteps) {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentStep((prev) => prev + 1);
        setIsAnimating(false);
      }, 150);
    }
  }, [currentStep, totalSteps]);

  const handleBack = useCallback(() => {
    if (currentStep > 1) {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentStep((prev) => prev - 1);
        setIsAnimating(false);
      }, 150);
    }
  }, [currentStep]);

  const handleStepClick = useCallback(
    (stepNumber: number) => {
      if (stepNumber !== currentStep && stepNumber <= currentStep) {
        setIsAnimating(true);
        setTimeout(() => {
          setCurrentStep(stepNumber);
          setIsAnimating(false);
        }, 150);
      }
    },
    [currentStep]
  );

  const getStepProgress = useCallback(() => {
    if (totalSteps <= 1) return 0;
    return ((currentStep - 1) / (totalSteps - 1)) * 100;
  }, [currentStep, totalSteps]);

  const resetStep = useCallback(() => {
    setCurrentStep(1);
  }, []);

  return {
    currentStep,
    isAnimating,
    handleNext,
    handleBack,
    handleStepClick,
    getStepProgress,
    resetStep,
  };
};
